module.exports = __webpack_public_path__ + "static/flags/SO-14d78f99a598c603f7c47ed580e30efe.gif";